import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d7691826"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  for: "checkbox",
  class: "switch-label"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "🌙", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "☀️", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("input", {
      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleTheme && _ctx.toggleTheme(...args))),
      id: "checkbox",
      type: "checkbox",
      class: "switch-checkbox"
    }, null, 32),
    _createElementVNode("label", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("div", {
        class: _normalizeClass(["switch-toggle", { 'switch-toggle-checked': _ctx.userTheme === 'dark-theme' }])
      }, null, 2)
    ])
  ]))
}